import styled from 'styled-components';
import DeleteSvg from '../../assets/settings/delete.svg';

const DeleteIcon = styled(DeleteSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '1.6rem'};
height: ${props => props.height || '1.9rem'};
margin: ${props => props.margin};
fill: ${props => props.fill};
cursor: pointer;
`;

export default DeleteIcon;
